import api from './api';

export function trackEvent(event_type: string, payload: Record<string, unknown> = {}): void {
  const { receiptId, ...rest } = payload as { receiptId?: string; [key: string]: unknown };
  api.post('/api/v1/events', { event_type, receipt_id: receiptId, payload: rest }).catch(() => {});
}
